module.exports = __webpack_public_path__ + "static/media/male-volleyball-player.11a90933.svg";